import BaseRadioButtonGroup from "./BaseRadioButtonGroup.vue";

export type { ItemOption } from "./BaseRadioButtonGroup.vue";
export default BaseRadioButtonGroup;
